import React from 'react';

import SimpleMessagePage from 'components/SimpleMessagePage';
import { useMarkdownTranslate } from 'hooks/useTranslate/useTranslate';

const UnifiedFraudAlert: React.FC = () => {
  const tMd = useMarkdownTranslate();
  return (
    <SimpleMessagePage
      headerTitle={'unified.placeOrder.error.fraudAlert.title'}
      message={tMd('unified.placeOrder.error.fraudAlert.message')}
    ></SimpleMessagePage>
  );
};

export default UnifiedFraudAlert;
